import type { DOMOutputSpec, Node as ProsemirrorNode, NodeSpec } from 'prosemirror-model';

import { NodeName } from '../../../schema/nodes';

export class ListItemNode implements NodeSpec {
  public static readonly nodeName = NodeName.ListItem;
  public static is(node: ProsemirrorNode) {
    return node.type.name === ListItemNode.nodeName;
  }
  public defining = true;
  public content = 'paragraph block*';
  public parseDOM = [{ tag: 'li' }];
  public toDOM = (): DOMOutputSpec => ['li', 0];
}
